module.exports = __webpack_public_path__ + "static/firstSectionPrimaryImage-942dba2678dd15224472ce178823e526.jpeg";